export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  date: string;
  author: string;
  rating: number;
  tags: string[];
  readTime: string;
  isTrending: boolean;
  isFeatured: boolean;
  views: number;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "剧情解析",
    slug: "plot-analysis",
    description: "深度剖析「妈妈的朋友2」的故事脉络、人物关系与情感内核",
    icon: "ri-film-line",
    articleCount: 8,
  },
  {
    id: "cat-2",
    name: "演员阵容",
    slug: "cast",
    description: "全面介绍电影主演与配角的演艺经历、角色塑造与幕后故事",
    icon: "ri-user-star-line",
    articleCount: 6,
  },
  {
    id: "cat-3",
    name: "观看指南",
    slug: "watching-guide",
    description: "正版观看渠道推荐、字幕版本对比与观影注意事项",
    icon: "ri-play-circle-line",
    articleCount: 5,
  },
  {
    id: "cat-4",
    name: "影评点评",
    slug: "reviews",
    description: "汇集专业影评人与观众的真实评价，多角度解读电影魅力",
    icon: "ri-chat-quote-line",
    articleCount: 10,
  },
  {
    id: "cat-5",
    name: "相关推荐",
    slug: "recommendations",
    description: "如果你喜欢「妈妈的朋友2」，这些同类型佳作不容错过",
    icon: "ri-thumb-up-line",
    articleCount: 7,
  },
];

export const articles: Article[] = [
  {
    id: "a1",
    slug: "mothers-friend-2-full-plot-summary",
    title: "「妈妈的朋友2」完整剧情梳理：一段跨越年龄的情感纠葛",
    excerpt: "电影《妈妈的朋友2》延续了前作的风格，讲述了一段发生在成年人与少年之间的复杂情感故事。本文为你详细梳理电影的完整剧情脉络，解读关键情节转折。",
    content: '<p>韩国电影《妈妈的朋友2》是2016年上映的一部剧情片，由金导演执导。影片延续了第一部的叙事风格，以细腻的笔触描绘了一段特殊的情感关系。</p><h2>故事背景</h2><p>影片的故事发生在一个平凡的韩国城市。男主角是一名正值青春期的少年，因家庭原因暂住在父亲的朋友家中。在这个陌生的环境里，他遇到了父亲朋友的妻子——一位成熟优雅的女性。两人在日常相处中逐渐产生了微妙的情感联系。</p><h2>剧情发展</h2><p>故事的开始，男主因为父母外出工作，被安排住进了父亲的好友家中。初到陌生环境的他显得拘谨而不安，但女主人的温柔体贴让他逐渐放下了戒心。她为他准备可口的饭菜，关心他的学业和生活，像一位真正的长辈那样照顾着他。</p><p>随着时间的推移，两人之间的关系开始发生微妙的变化。男主对这个成熟女性产生了超越普通感情的情愫，而女主人也在日复一日的相处中，对这个纯真少年有了不一样的感觉。这种情感在两人之间悄然滋长，却又因为道德和世俗的约束而无法言说。</p><h2>情感高潮</h2><p>影片中最令人动容的场景，莫过于那个雨夜。当两人独处一室，窗外的雨声敲打着玻璃，内心的情感终于冲破了一切束缚。这场戏的处理极为克制而富有张力，导演用细腻的镜头语言传达出了角色内心深处的挣扎与渴望。</p><h2>结局解读</h2><p>电影的结局留给观众广阔的想象空间。这段特殊的情感最终以男主的离开而画上句号，但两人心中留下的印记却永远不会消失。这种开放式的结局恰恰是影片的高明之处，它不评判、不定义，只是真实地呈现了人性中最复杂、最柔软的部分。</p><h2>影片主题</h2><p>《妈妈的朋友2》探讨了爱情与道德的边界、青春期的懵懂与成长的代价。影片没有刻意煽情，而是用平实的叙事手法，让观众自己去感受和思考。这种内敛的表达方式，恰恰是韩国电影的一大特色。</p>',
    category: "剧情解析",
    categorySlug: "plot-analysis",
    imageUrl: "https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20soft%20warm%20lighting%2C%20two%20people%20sitting%20in%20a%20cozy%20living%20room%2C%20emotional%20atmosphere%2C%20Korean%20film%20aesthetic%2C%20subtle%20warm%20tones%2C%20intimate%20moment%2C%20rain%20on%20window%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=article-plot-01&orientation=landscape",
    date: "2025-11-20",
    author: "影评人老王",
    rating: 7.5,
    tags: ["妈妈的朋友2", "剧情解析", "韩国电影", "情感"],
    readTime: "8分钟",
    isTrending: true,
    isFeatured: true,
    views: 15680,
  },
  {
    id: "a2",
    slug: "mothers-friend-2-cast-introduction",
    title: "「妈妈的朋友2」演员阵容全解析：主演们的精彩演绎",
    excerpt: "《妈妈的朋友2》之所以能打动无数观众，演员们的精湛演技功不可没。本文将为你详细介绍影片的主要演员阵容及他们在片中的角色塑造。",
    content: '<p>《妈妈的朋友2》的成功，离不开演员们真挚动人的表演。每一位演员都将角色的内心世界刻画得入木三分，让观众能够真切地感受到角色的喜怒哀乐。下面，我们将逐一介绍影片的主要演员。</p><h2>女主角：优雅成熟的魅力</h2><p>女主角由韩国实力派女演员饰演。她在片中塑造了一位温柔、善良却又内心充满矛盾的成熟女性形象。她的表演极为细腻，通过眼神、微表情和肢体语言，将一个女人在道德与情感之间的挣扎展现得淋漓尽致。尤其是在那些安静的独处场景中，她仅凭一个眼神就能传递出千言万语。</p><h2>男主角：青春期的懵懂与成长</h2><p>男主角由一位新生代演员出演。他将一个青春期少年的青涩、敏感和冲动演绎得非常到位。从最初的拘谨不安，到后来情感的萌芽和爆发，每一个阶段的转变都自然流畅。特别值得一提的是，在表现内心矛盾时的那些细微表情变化，让人印象深刻。</p><h2>配角阵容</h2><p>影片的配角同样表现出色。男主角的父亲虽然戏份不多，但每一次出场都充满分量；父亲的朋友作为关键人物，他的表演克制而富有层次感；其他配角的演出也都为影片增色不少，共同构建了一个真实而立体的人物群像。</p><h2>演员之间的化学反应</h2><p>最令人称道的是男女主角之间的化学反应。两人在银幕上的互动自然而充满张力，那种若即若离的距离感把握得恰到好处。这种默契的配合，让观众完全沉浸在故事之中，忘记了这只是表演。</p>',
    category: "演员阵容",
    categorySlug: "cast",
    imageUrl: "https://readdy.ai/api/search-image?query=Korean%20film%20actors%20portrait%2C%20elegant%20mature%20woman%20in%20warm%20indoor%20setting%2C%20soft%20natural%20lighting%2C%20emotional%20expression%2C%20cinematic%20portrait%20style%2C%20warm%20earth%20tones%2C%20minimal%20composition%2C%20Korean%20drama%20aesthetic&width=800&height=450&seq=article-cast-01&orientation=landscape",
    date: "2025-11-15",
    author: "影评人老王",
    rating: 7.8,
    tags: ["妈妈的朋友2", "演员阵容", "韩国演员", "演技"],
    readTime: "6分钟",
    isTrending: true,
    isFeatured: false,
    views: 12450,
  },
  {
    id: "a3",
    slug: "mothers-friend-2-where-to-watch",
    title: "「妈妈的朋友2」正版观看渠道汇总：在哪里可以观看？",
    excerpt: "想观看《妈妈的朋友2》但不知道从哪里找正版资源？本文为你整理目前可用的正版观看渠道、字幕版本对比以及观影建议，帮助你获得最佳观影体验。",
    content: '<p>随着流媒体平台的普及，越来越多的韩国电影可以通过正规渠道观看。《妈妈的朋友2》作为一部备受关注的影片，目前已经登陆多个主流平台。</p><h2>主流流媒体平台</h2><p>目前《妈妈的朋友2》已在多个流媒体平台上线，观众可以根据自己的需求选择合适的平台观看。建议优先选择提供高清画质和中文字幕的平台，以获得最佳观影体验。</p><h2>观影注意事项</h2><p>在观看影片时，建议使用正版渠道，不仅可以获得更好的画质和翻译质量，也是对电影创作者的支持。同时，部分平台可能需要会员订阅才能观看完整内容。</p><h2>字幕版本对比</h2><p>不同平台提供的字幕翻译可能存在差异。建议选择口碑较好的翻译版本，以确保能够准确理解影片中细腻的情感表达和文化内涵。</p><h2>观影建议</h2><p>观看前可以适当了解影片的背景信息，但建议不要过度剧透。影片中的情感表达极为细腻，需要静下心来慢慢品味。建议在安静的环境中，给自己留出充足的时间来完整地欣赏这部作品。</p>',
    category: "观看指南",
    categorySlug: "watching-guide",
    imageUrl: "https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20film%2C%20warm%20ambient%20lighting%2C%20comfortable%20couch%2C%20movie%20night%20atmosphere%2C%20cinematic%20experience%2C%20soft%20golden%20light%2C%20modern%20living%20room&width=800&height=450&seq=article-watch-01&orientation=landscape",
    date: "2025-11-10",
    author: "影视导航员",
    rating: 7.2,
    tags: ["妈妈的朋友2", "观看指南", "正版渠道", "流媒体"],
    readTime: "5分钟",
    isTrending: false,
    isFeatured: true,
    views: 18920,
  },
  {
    id: "a4",
    slug: "mothers-friend-2-professional-review",
    title: "专业影评：「妈妈的朋友2」中的道德困境与人性温度",
    excerpt: "《妈妈的朋友2》不仅是一部情感电影，更是一部引发观众思考的作品。本文从专业影评角度，深入分析影片中呈现的道德困境与人性温度。",
    content: '<p>在韩国电影的谱系中，《妈妈的朋友2》是一部值得深入探讨的作品。它不仅仅讲述了一个关于禁忌之恋的故事，更通过这个故事折射出了人性的复杂面向和道德的灰色地带。</p><h2>道德困境的呈现</h2><p>影片最核心的张力来自于道德与情感的冲突。女主角作为一位已婚女性，在道德上不应该对丈夫朋友的儿子产生超越界限的感情。而男主角作为一个未成年人，他的情感冲动是否可以被理解和原谅？这些问题影片没有给出明确的答案，而是留给观众自己去思考。</p><h2>人性温度的刻画</h2><p>尽管涉及敏感的题材，但影片的处理方式极为克制和温暖。导演没有猎奇式地渲染禁忌之恋的刺激感，而是用大量日常生活的细节来铺垫两人的感情发展。这种细腻的叙事手法，让观众能够理解角色的行为动机，而非简单地做出道德判断。</p><h2>与其他同类型影片的对比</h2><p>相比于同类题材的其他电影，《妈妈的朋友2》更加注重情感的真实性而非戏剧冲突。影片的节奏舒缓，镜头语言克制，整体氛围充满了韩国电影特有的内敛之美。这种风格虽然不如商业大片那样具有冲击力，但更能触动观众内心深处的共鸣。</p><h2>总评</h2><p>《妈妈的朋友2》是一部值得静下心来观看的电影。它不追求情节的跌宕起伏，而是通过细腻的情感描写和对人性的深入探讨，给观众留下了深刻的印象。评分：7.5/10。</p>',
    category: "影评点评",
    categorySlug: "reviews",
    imageUrl: "https://readdy.ai/api/search-image?query=Artistic%20film%20review%20concept%2C%20vintage%20movie%20projector%20with%20warm%20light%20beam%2C%20dark%20background%20with%20soft%20glow%2C%20cinematic%20atmosphere%2C%20film%20reel%20texture%2C%20nostalgic%20warm%20amber%20tones%2C%20elegant%20minimal%20composition&width=800&height=450&seq=article-review-01&orientation=landscape",
    date: "2025-11-05",
    author: "影评人老王",
    rating: 7.5,
    tags: ["妈妈的朋友2", "影评", "道德困境", "人性"],
    readTime: "7分钟",
    isTrending: false,
    isFeatured: false,
    views: 9870,
  },
  {
    id: "a5",
    slug: "mothers-friend-2-audience-reviews",
    title: "观众的真实声音：「妈妈的朋友2」各大平台评分汇总",
    excerpt: "《妈妈的朋友2》在各大影视平台上的评价如何？本文汇总了豆瓣、IMDb等主流平台的观众评分与热门评论，帮你了解大众对这部电影的真实看法。",
    content: '<p>一部电影的好坏，观众的反馈往往是最真实的评判标准。我们整理了《妈妈的朋友2》在各大平台上的评分数据和热门评论，带你了解观众的真实声音。</p><h2>豆瓣评分</h2><p>在豆瓣平台上，《妈妈的朋友2》获得了相对稳定的评分。观众的评价主要集中在影片的情感表达和演员表现上。正面评价多称赞影片"感情真挚""演员演技在线"，而负面评价则主要集中在剧情节奏较慢和题材争议上。</p><h2>IMDb评分</h2><p>在国际影评平台IMDb上，影片同样获得了一定的关注度。国际观众对韩国电影独特的情感表达方式给予了肯定，认为影片的摄影和配乐都达到了较高的水准。</p><h2>观众热评精选</h2><p>"一部让人看完后久久不能平静的电影，女主角的眼神戏太绝了。" —— 豆瓣网友</p><p>"韩国人真的很会拍这种细腻的情感，明明没有什么大场面，却让人看得揪心。" —— 知乎网友</p><p>"虽然题材有点争议，但导演的处理方式很成熟，没有让人觉得不适。" —— 微博网友</p>',
    category: "影评点评",
    categorySlug: "reviews",
    imageUrl: "https://readdy.ai/api/search-image?query=Movie%20rating%20concept%20with%20golden%20stars%20on%20dark%20cinematic%20background%2C%20audience%20review%20aesthetic%2C%20warm%20amber%20glow%2C%20film%20critic%20vibe%2C%20elegant%20minimal%20design%2C%20soft%20bokeh%20lights&width=800&height=450&seq=article-audience-01&orientation=landscape",
    date: "2025-10-28",
    author: "影视导航员",
    rating: 7.3,
    tags: ["妈妈的朋友2", "观众评价", "评分", "影评"],
    readTime: "5分钟",
    isTrending: true,
    isFeatured: false,
    views: 22300,
  },
  {
    id: "a6",
    slug: "mothers-friend-2-themes-analysis",
    title: "深度解读：「妈妈的朋友2」中的孤独、欲望与救赎",
    excerpt: "在表面的情感故事之下，《妈妈的朋友2》实际上探讨了更为深刻的主题——现代人的孤独感、被压抑的欲望以及通过情感连接实现的自我救赎。",
    content: '<p>如果仅仅将《妈妈的朋友2》看作一部关于禁忌之恋的电影，那是对这部作品的极大误解。在这段看似简单的情感故事背后，隐藏着对现代人精神困境的深刻洞察。</p><h2>孤独：现代人的普遍困境</h2><p>影片中的两位主角，尽管年龄、身份和境遇各不相同，但他们都共享着同一种情感——孤独。女主角的孤独来自于婚姻中的情感缺失，而男主角的孤独则源于青春期的身份困惑和被忽视的成长需求。正是这种共同的孤独感，让两个本不该产生交集的人走到了一起。</p><h2>欲望：被压抑的真实自我</h2><p>影片中人物的欲望表达极为克制，但这种克制反而增强了欲望的张力。女主角渴望被真正地理解和关爱，男主角则渴望被当作成年人来对待和尊重。这些深层的心理需求通过日常生活的细节被巧妙地呈现出来。</p><h2>救赎：在连接中找到出口</h2><p>影片的结局虽然充满了遗憾，但并非绝望。通过这段特殊的经历，两个人都获得了某种程度上的成长和救赎。男主角在这段关系中学会了什么是真正的情感，而女主角则重新认识了自己的内心需求。</p>',
    category: "剧情解析",
    categorySlug: "plot-analysis",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20concept%20of%20loneliness%20and%20connection%2C%20two%20silhouettes%20facing%20each%20other%20in%20warm%20golden%20light%2C%20soft%20atmospheric%20haze%2C%20emotional%20depth%2C%20artistic%20film%20aesthetic%2C%20minimal%20composition%2C%20warm%20earth%20tones&width=800&height=450&seq=article-theme-01&orientation=landscape",
    date: "2025-10-20",
    author: "影评人老王",
    rating: 8.0,
    tags: ["妈妈的朋友2", "深度解读", "孤独", "救赎"],
    readTime: "8分钟",
    isTrending: false,
    isFeatured: true,
    views: 8760,
  },
  {
    id: "a7",
    slug: "mothers-friend-2-cinematography",
    title: "视觉之美：「妈妈的朋友2」摄影与美术设计赏析",
    excerpt: "韩国电影向来以精致的视觉呈现著称，《妈妈的朋友2》也不例外。本文从摄影构图、光影运用和美术设计三个维度，解析影片的视觉美学。",
    content: '<p>《妈妈的朋友2》在视觉呈现上延续了韩国电影一贯的高水准。影片的摄影指导通过精妙的构图和光影运用，为这个情感故事增添了丰富的视觉层次。</p><h2>摄影构图</h2><p>影片大量使用了框架式构图和纵深构图，通过门框、窗户等元素来强调人物之间的距离感和心理隔阂。尤其是在室内场景中，摄影师巧妙地利用空间布局来暗示人物之间的关系变化。</p><h2>光影运用</h2><p>光影是影片最重要的视觉语言之一。自然光的大量使用营造出了真实而温暖的氛围，而在关键的情感场景中，光影的变化成为表达人物内心状态的重要手段。雨夜场景中的暗调光影处理尤为出色。</p><h2>色彩调性</h2><p>整部影片的色彩以暖色调为主，大量使用棕色、米色和柔和的黄色，营造出一种温馨而略带怀旧的视觉感受。这种色彩处理与影片的情感基调高度统一。</p>',
    category: "剧情解析",
    categorySlug: "plot-analysis",
    imageUrl: "https://readdy.ai/api/search-image?query=Korean%20film%20cinematography%20aesthetic%2C%20warm%20indoor%20scene%20with%20natural%20window%20light%2C%20soft%20shadows%20and%20highlights%2C%20cinematic%20composition%20with%20depth%2C%20warm%20amber%20and%20brown%20tones%2C%20elegant%20minimal%20interior&width=800&height=450&seq=article-cinema-01&orientation=landscape",
    date: "2025-10-15",
    author: "影视导航员",
    rating: 7.6,
    tags: ["妈妈的朋友2", "摄影", "视觉效果", "美学"],
    readTime: "6分钟",
    isTrending: false,
    isFeatured: false,
    views: 6540,
  },
  {
    id: "a8",
    slug: "mothers-friend-series-comparison",
    title: "系列对比：「妈妈的朋友」第一部与第二部的异同",
    excerpt: "作为系列电影的第二部，《妈妈的朋友2》在延续前作风格的同时也做出了许多创新。本文从剧情、人物、主题三个维度对比两部作品的异同。",
    content: '<p>《妈妈的朋友》系列电影在韩国影坛独树一帜，每一部都有其独特的魅力。将两部作品进行对比分析，可以帮助我们更好地理解这个系列的创作脉络。</p><h2>剧情结构对比</h2><p>第一部的故事更加线性，聚焦于单一的人物关系发展。而第二部在保持主线清晰的同时，增加了更多的支线情节和人物互动，使得故事层次更加丰富。</p><h2>人物塑造演变</h2><p>从人物塑造来看，第二部的角色更加立体和复杂。女主角不再只是一个温柔的"母亲"形象，她的内心矛盾和挣扎被更加深入地展现。男主角的角色也从单纯的少年形象成长为一个更加有自我意识的人物。</p><h2>主题深化的轨迹</h2><p>在主题表达上，第二部有了明显的深化。如果说第一部更多地停留在情感描写层面，那么第二部则勇敢地触及了更为深层的社会议题和人性探讨。</p>',
    category: "相关推荐",
    categorySlug: "recommendations",
    imageUrl: "https://readdy.ai/api/search-image?query=Film%20series%20comparison%20concept%2C%20two%20overlapping%20film%20frames%20with%20warm%20cinematic%20lighting%2C%20vintage%20movie%20aesthetic%2C%20soft%20golden%20tones%2C%20elegant%20minimal%20composition%2C%20film%20reel%20elements&width=800&height=450&seq=article-series-01&orientation=landscape",
    date: "2025-10-08",
    author: "影评人老王",
    rating: 7.4,
    tags: ["妈妈的朋友2", "系列对比", "电影系列"],
    readTime: "6分钟",
    isTrending: false,
    isFeatured: false,
    views: 5430,
  },
  {
    id: "a9",
    slug: "similar-movies-recommendation",
    title: "喜欢「妈妈的朋友2」？这5部同类型韩国电影不容错过",
    excerpt: "如果你被《妈妈的朋友2》中细腻的情感表达所打动，那么这5部同样以情感刻画见长的韩国电影也一定不会让你失望。",
    content: '<p>韩国电影在处理情感题材方面有着独特的优势，以下推荐5部与《妈妈的朋友2》风格相近的优秀作品。</p><h2>推荐一：《晚秋》</h2><p>这部由汤唯和玄彬主演的爱情电影，同样以极为克制的叙事手法讲述了一段特殊的感情。影片的节奏缓慢而沉稳，情感表达却极为有力。</p><h2>推荐二：《绿洲》</h2><p>李沧东导演的这部作品探讨了边缘人群之间的爱情，影片对人性的洞察和情感的真实表达令人动容。</p><h2>推荐三：《男与女》</h2><p>同样关于禁忌之恋的题材，影片通过两位中年男女的情感纠葛，探讨了婚姻、道德与真实情感之间的冲突。</p><h2>推荐四：《春逝》</h2><p>许秦豪导演的经典爱情片，以极为优美的视听语言讲述了一段注定要结束的恋情，情感表达细腻而忧伤。</p><h2>推荐五：《情事》</h2><p>李在容导演的作品，讲述了一段发生在兄妹之间的禁忌情感，影片对人性深处的欲望与克制进行了深刻的探讨。</p>',
    category: "相关推荐",
    categorySlug: "recommendations",
    imageUrl: "https://readdy.ai/api/search-image?query=Collection%20of%20Korean%20film%20posters%20in%20artistic%20arrangement%2C%20warm%20cinematic%20lighting%2C%20elegant%20gallery%20wall%20display%2C%20soft%20amber%20tones%2C%20film%20culture%20aesthetic%2C%20minimal%20composition%20with%20depth&width=800&height=450&seq=article-recommend-01&orientation=landscape",
    date: "2025-09-28",
    author: "影视导航员",
    rating: 7.8,
    tags: ["妈妈的朋友2", "电影推荐", "韩国电影", "同类型"],
    readTime: "6分钟",
    isTrending: true,
    isFeatured: false,
    views: 14560,
  },
  {
    id: "a10",
    slug: "mothers-friend-2-behind-scenes",
    title: "幕后故事：「妈妈的朋友2」拍摄花絮与创作理念",
    excerpt: "每一部优秀电影的背后，都有许多不为人知的故事。本文带你走进《妈妈的朋友2》的拍摄幕后，了解导演的创作理念和演员们的拍摄趣事。",
    content: '<p>《妈妈的朋友2》的拍摄过程充满了挑战和感动。导演和演员们在有限的预算和时间内，以极大的热情和专业精神完成了这部作品。</p><h2>导演的创作理念</h2><p>导演在接受采访时表示，他希望通过这部电影探讨"什么是真正的爱"，而不是简单地讲述一个禁忌之恋的故事。他认为，爱与道德的冲突是永恒的艺术主题，关键在于如何以真诚的态度去呈现。</p><h2>拍摄中的挑战</h2><p>影片中有大量的室内场景和情感戏份，这对演员的表演提出了很高的要求。为了让演员更好地进入角色状态，导演采用了大量的即兴排练和情感引导，让演员在自然的状态下完成表演。</p><h2>演员的真实感受</h2><p>女主角在一次采访中透露，饰演这个角色让她经历了一次深刻的情感旅程。为了更好地理解角色的内心世界，她阅读了大量关于情感心理学的书籍，并与导演进行了长时间的深入交流。</p>',
    category: "演员阵容",
    categorySlug: "cast",
    imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%2C%20director%20and%20actors%20discussing%20scene%20on%20set%2C%20warm%20studio%20lighting%2C%20camera%20equipment%20in%20background%2C%20cinematic%20production%20atmosphere%2C%20professional%20film%20crew%2C%20documentary%20style&width=800&height=450&seq=article-bts-01&orientation=landscape",
    date: "2025-09-20",
    author: "影评人老王",
    rating: 7.0,
    tags: ["妈妈的朋友2", "幕后故事", "拍摄花絮", "创作"],
    readTime: "5分钟",
    isTrending: false,
    isFeatured: false,
    views: 4320,
  },
  {
    id: "a11",
    slug: "mothers-friend-2-music-ost",
    title: "旋律中的情感：「妈妈的朋友2」原声音乐赏析",
    excerpt: "一部优秀的电影离不开动人的配乐。《妈妈的朋友2》的原声音乐以钢琴和弦乐为主，完美地衬托了影片的情感氛围。",
    content: '<p>电影的配乐是传递情感的重要媒介。《妈妈的朋友2》的原声音乐由韩国著名音乐人操刀，以简洁而富有情感的旋律打动了无数观众。</p><h2>主题旋律</h2><p>影片的主题旋律以钢琴独奏为主，简单的音符在安静的氛围中缓缓流淌，营造出一种淡淡的忧伤和温暖的氛围。这段旋律在影片的关键情节中反复出现，成为连接观众与角色情感的重要纽带。</p><h2>配乐的风格特点</h2><p>整部影片的配乐以极简主义为基调，大量使用了钢琴、小提琴和大提琴等弦乐器。音乐不喧宾夺主，而是恰到好处地衬托画面的情感表达，让观众在不经意间被音乐所感染。</p><h2>经典场景配乐分析</h2><p>在影片最动人的雨夜场景中，配乐以极弱的音量出现，几乎融入了环境音之中。这种处理方式极为巧妙，既增强了场景的沉浸感，又不至于让音乐过度渲染情绪。这正是韩国电影配乐的高明之处。</p>',
    category: "剧情解析",
    categorySlug: "plot-analysis",
    imageUrl: "https://readdy.ai/api/search-image?query=Music%20sheet%20with%20warm%20cinematic%20lighting%2C%20piano%20keys%20in%20soft%20focus%2C%20vintage%20music%20aesthetic%2C%20golden%20amber%20light%2C%20emotional%20atmosphere%2C%20elegant%20minimal%20composition%2C%20film%20score%20concept&width=800&height=450&seq=article-ost-01&orientation=landscape",
    date: "2025-09-15",
    author: "影视导航员",
    rating: 7.3,
    tags: ["妈妈的朋友2", "原声音乐", "OST", "配乐"],
    readTime: "5分钟",
    isTrending: false,
    isFeatured: false,
    views: 3890,
  },
  {
    id: "a12",
    slug: "mothers-friend-2-cultural-impact",
    title: "文化影响：「妈妈的朋友2」引发的社会讨论",
    excerpt: "《妈妈的朋友2》上映后不仅在影迷中引发了热议，也在更广泛的社会层面激起了关于爱情、道德和年龄差距的讨论。",
    content: '<p>一部有深度的电影，往往能够在社会层面引发广泛的讨论。《妈妈的朋友2》正是这样一部作品，它触及的议题超越了电影本身，成为了社会文化讨论的一部分。</p><h2>关于年龄差距恋爱的讨论</h2><p>影片上映后，关于年龄差距恋爱的话题在社交媒体上引发了热烈的讨论。支持者认为爱情不应被年龄所限制，反对者则强调社会责任和道德约束的重要性。这种多元的声音恰恰反映了当代社会价值观的复杂性。</p><h2>女性议题的呈现</h2><p>影片中女主角的形象塑造也引发了对女性议题的讨论。作为一个已婚女性，她在婚姻、情感和自我价值之间的挣扎，折射出许多当代女性面临的实际困境。</p><h2>韩国电影的情感表达传统</h2><p>有评论指出，《妈妈的朋友2》延续了韩国电影一贯的情感表达传统——克制而深刻。这种表达方式与好莱坞式的直白形成了鲜明对比，体现了东亚文化中特有的含蓄之美。</p>',
    category: "影评点评",
    categorySlug: "reviews",
    imageUrl: "https://readdy.ai/api/search-image?query=Social%20discussion%20concept%20in%20cinematic%20style%2C%20people%20silhouettes%20in%20warm%20conversation%2C%20soft%20atmospheric%20lighting%2C%20cultural%20discourse%20aesthetic%2C%20warm%20amber%20and%20brown%20tones%2C%20thoughtful%20composition&width=800&height=450&seq=article-culture-01&orientation=landscape",
    date: "2025-09-08",
    author: "影评人老王",
    rating: 7.7,
    tags: ["妈妈的朋友2", "文化影响", "社会讨论", "议题"],
    readTime: "5分钟",
    isTrending: false,
    isFeatured: false,
    views: 5100,
  },
];

export const siteInfo = {
  name: "妈妈的朋友2 影迷资讯站",
  description: "致力于为影迷提供「妈妈的朋友2」最全面的剧情解析、演员阵容介绍、观看指南和影评点评。",
  foundingYear: "2025",
  totalArticles: articles.length,
  totalViews: articles.reduce((sum, a) => sum + a.views, 0),
  avgRating: (articles.reduce((sum, a) => sum + a.rating, 0) / articles.length).toFixed(1),
};

export const faqData = [
  {
    question: "「妈妈的朋友2」是什么类型的电影？",
    answer: "《妈妈的朋友2》是一部韩国剧情片，属于情感题材电影。影片讲述了一段发生在成年女性与青春期少年之间的特殊情感故事，以细腻的叙事手法探讨了爱情、道德与人性的复杂面向。",
  },
  {
    question: "「妈妈的朋友2」在哪里可以观看？",
    answer: "《妈妈的朋友2》已登陆多个主流流媒体平台，建议通过正版渠道观看以获得最佳画质和翻译体验。具体平台信息请查看本站的观看指南栏目。",
  },
  {
    question: "「妈妈的朋友2」的评分怎么样？",
    answer: "根据各大平台的综合评分，《妈妈的朋友2》获得了中等偏上的评价。观众普遍认为影片的情感表达真挚、演员演技在线，是一部值得观看的韩国电影。",
  },
  {
    question: "「妈妈的朋友2」和第一部有什么关系？",
    answer: "《妈妈的朋友2》是系列电影的第二部作品。两部作品在主题上有延续性，但在故事和人物上是独立的。第二部在主题深度和人物塑造上有了明显的提升。",
  },
  {
    question: "「妈妈的朋友2」适合什么年龄段观看？",
    answer: "由于影片涉及成人情感题材，建议18岁以上观众观看。影片的情感表达较为克制，但主题内容需要一定的人生阅历才能更好地理解和体会。",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "张先生",
    location: "北京",
    rating: 5,
    comment: "这个网站的情报非常全面，让我对这部电影有了全新的认识。特别是剧情解析部分写得非常深入！",
    date: "2025-11-01",
  },
  {
    id: "t2",
    name: "李女士",
    location: "上海",
    rating: 5,
    comment: "终于找到一个专门介绍《妈妈的朋友2》的中文网站了，文章质量很高，看得出是用心做的。",
    date: "2025-10-25",
  },
  {
    id: "t3",
    name: "王同学",
    location: "广州",
    rating: 4,
    comment: "文章写得很专业，演员阵容的介绍特别详细，帮助我更好地理解了每个角色的特点。",
    date: "2025-10-18",
  },
  {
    id: "t4",
    name: "赵先生",
    location: "深圳",
    rating: 5,
    comment: "观看指南那一篇非常实用，让我找到了合适的平台来观看这部电影，非常感谢！",
    date: "2025-10-10",
  },
  {
    id: "t5",
    name: "刘女士",
    location: "成都",
    rating: 5,
    comment: "网站设计很漂亮，内容也很丰富。影评部分的分析角度很独特，让我看到了很多之前没有注意到的细节。",
    date: "2025-09-28",
  },
  {
    id: "t6",
    name: "陈先生",
    location: "杭州",
    rating: 4,
    comment: "作为电影爱好者，这个网站的深度分析让我非常满意，已经推荐给朋友了。",
    date: "2025-09-20",
  },
];